<template>
  <div class="login-view">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1 class="text-center text-xl bold my-5 text-uppercase">{{$t('auth.login')}}</h1>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-6 col-xl-5">
          <div class="mb-4">
            <b-alert v-if="sessionExpired"
                     dismissible
                     fade
                     :show="dismissCountDown"
                     @dismissed="dismissCountDown=0"
                     @dismiss-count-down="countDownChanged"
                     variant="warning">
              <span class="text-sm">{{$t('auth.sessionExpired')}}</span>
            </b-alert>
          </div>
          <LoginForm :goBackAfterLogin="goBackAfterLogin"/>
          <div class="d-flex justify-content-between mt-4">
            <router-link to="/forgot-password" class="menu-item d-inline-block">
              <span class="text-secondary text-xs m-0">{{$t('auth.forgotPassword')}}</span>
            </router-link>
            <router-link to="/signup" class="menu-item d-inline-block">
              <span class="text-secondary text-xs m-0 text-uppercase">{{$t('auth.signup')}}</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoginForm from '@/components/LoginForm.vue';

export default {
  metaInfo() {
    return {
      title: `${this.$t('auth.login')} - Nissens Support`,
    };
  },
  components: {
    LoginForm,
  },
  data() {
    return {
      sessionExpired: false,
      dismissSecs: 10,
      dismissCountDown: 0,
      goBackAfterLogin: true,
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.user.status.loggedIn;
    },
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
  },
  mounted() {
    if (this.loggedIn) {
      this.$router.push('/profile');
    }
    if (this.$route.query.session_expired) {
      this.sessionExpired = true;
      this.dismissCountDown = this.dismissSecs;
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.name === null || from.name === 'Signup') {
      next((vm) => { vm.goBackAfterLogin = false; });
    } else {
      next();
    }
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
.login-view ::v-deep {
  form {
    .input-group-prepend > div {
      background-color: white;
    }
    input, select {
      padding: .8rem 1rem;
      height: unset;
    }
    svg {
      color: #c7c7c7;
    }
  }
  .password-container {
    margin-bottom: 30px;
  }
  .button-container {
    display: flex;
    justify-content: center;
  }
  .form-error {
    color: $tertiary;
  }
}
</style>
